const NON_LIVE_SOURCE = /\b(?:demo|fixture|mock|sample|synthetic)\b/i;

export function requireLiveMarketSource(origin: unknown, source: unknown, label: string): string {
  if (origin !== "live_provider") {
    throw new Error(`${label} returned test data. Live market data is required.`);
  }

  if (typeof source !== "string" || !source.trim()) {
    throw new Error(`${label} did not identify a live source.`);
  }

  const normalized = source.trim();
  if (NON_LIVE_SOURCE.test(normalized)) {
    throw new Error(`${label} returned test data. Live market data is required.`);
  }

  return normalized;
}
